module.exports = __webpack_public_path__ + "static/back_to_the_woods2-d82f954d03ad005c5256228f637627d3.jpg";